import { Button, message, Popover, Table, Tabs } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { appUiActions } from "../../../../config/actions/app/appUi.actions";
import { numberWithCommas } from "../../../../config/helpers/app/numberFormater";
import routes from "../../../../config/routes/routes";
import generatePDF from "../../../../config/services/generatePdf";
import tableButtonActions from "../../../shared/Tables/TableButtonActions";
import TableTitle from "../../../shared/Tables/TableTitle";

const BudgetsTable = ({
  handleDelete,
  handleRefreshTable,
  handleExportRecords,
}) => {
  const [deleteId, setDeleteId] = useState("");
  const [filterTable, setfilterTable] = useState(null);
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    budgets: data,
    budgetsLoading: loading,
    budgetsSuccess: success,
    budgetsError: error,
    deleteBudgetLoading: deleteLoading,
    deleteBudgetSuccess: deleteSuccess,
    deleteBudgetError: deleteError,
    deleteBudgetMessage: deleteMessage,
  } = useSelector((state) => state.budgetState);
  const {
    success: logDetailsSuccess,
    error: logDetailsError,
    records,
  } = useSelector((state) => state.logDetailsState.addLogDetails);
  const columns = [
    {
      title: "Project",
      key: "project",
      render: (text) => (
        <div>
          <span className="d-md-none">Project:</span> {text.project} <br />
          <div className="d-md-none">
            <Popover
              className=""
              trigger="click"
              placement="bottom"
              content={() =>
                tableButtonActions(text, {
                  viewDetails,
                  updateRecord,
                  confirmDelete,
                  deleteRecord,
                  deleteLoading,
                  deleteId,
                })
              }
            >
              Actions: <Button type="link">Actions</Button>
            </Popover>
          </div>
        </div>
      ),
    },
    {
      title: "Approved Budget",
      key: "budget",
      dataIndex: "approved_budget",
      responsive: ["md"],
      render: (text) => {
        try {
          let currency = text[text?.length - 1];
          return (
            <>{`${currency === "D" ? "USD" : "UGX"} ${numberWithCommas(
              parseInt(text)
            )}`}</>
          );
        } catch (error) {
          return "";
        }
      },
    },
    {
      title: "Action",
      key: "operation",
      responsive: ["md"],
      render: (text) => (
        <Popover
          trigger="click"
          placement="bottom"
          content={() =>
            tableButtonActions(text, {
              viewDetails,
              updateRecord,
              confirmDelete,
              deleteRecord,
              deleteLoading,
              deleteId,
            })
          }
        >
          <Button>Actions</Button>
        </Popover>
      ),
    },
  ];
  /* Functions */
  const deleteRecord = (e) => setDeleteId(e.target.id);
  const confirmDelete = () => {
    const deleteObjectArray = data.filter((r) => r.id === deleteId);
    const budgetsArray = data.filter((e) => e.id !== deleteId);
    handleDelete(deleteId, deleteObjectArray[0]?.project, budgetsArray);
  };
  const refreshTable = () => {
    handleRefreshTable();
    if (!success && error) message.error(error);
  };
  const viewDetails = (e) => {
    history.push(`${routes.finance.budget.path}/${e.target.id}`);
  };
  const search = (value) => {
    const filterTable = data.filter((o) =>
      Object.keys(o).some((k) =>
        String(o[k]).toLowerCase().includes(value.toLowerCase())
      )
    );
    setfilterTable(filterTable);
  };
  const setfilterTableNull = (e) => {
    if (!e.target.value) setfilterTable(null);
  };
  const updateRecord = () => message.info("Click more for  budget preparation");
  const showTotal = (total) => `Total: ${total}`;
  const openAddModal = () => dispatch(appUiActions.toggleAddBudgetModal(true));
  const exportRecords = () => {
    message.loading("Proccessing document for export please wait ", 3);
    handleExportRecords();
  };
  const generateRecordsPdf = () => {
    const pdfColumns = ["Project", "Approved  Budget", "Status"];
    let pdfRows = [];
    data?.forEach((record) => {
      try {
        let currency =
          record?.approved_budget[record.approved_budget?.length - 1];
        const row = [
          record.project,
          `${currency === "D" ? "USD" : "UGX"} ${parseInt(
            record.approved_budget
          )}`,
          record.status.toUpperCase(),
        ];
        pdfRows.push(row);
      } catch (error) {
        console.error(error);
        pdfRows.push([]);
      }
    });
    generatePDF(
      pdfRows,
      pdfColumns,
      `Amani Intiative Budgets - ${new Date().toLocaleDateString()}`,
      "Amani Intiatice Budgers.pdf"
    );
  };
  /* Use effect */
  useEffect(() => {
    if (logDetailsSuccess && records === "budgets") {
      message.info("Started download");
      generateRecordsPdf();
    } else if (!logDetailsSuccess && logDetailsError)
      message.error(logDetailsError);
    if (deleteSuccess && deleteMessage) message.success(deleteMessage);
    else if (!deleteSuccess && deleteError) message.error(deleteError);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    logDetailsSuccess,
    logDetailsError,
    deleteSuccess,
    deleteMessage,
    deleteError,
  ]);

  return (
    <div>
      <Tabs
        type="card"
        tabBarStyle={{
          marginBottom: "0",
        }}
        items={[
          {
            label: "ACTIVE BUDGETS",
            key: "activeProjects",
            children: (
              <Table
                rowKey={(r) => r.id}
                loading={loading}
                title={() =>
                  TableTitle({
                    search,
                    setfilterTableNull,
                    refreshTable,
                    exportRecords,
                    openAddModal,
                  })
                }
                bordered={true}
                dataSource={filterTable === null ? data.activeBudgets : filterTable}
                columns={columns}
              />
            ),
          },
          {
            label: "COMPLETED BUDGETS",
            key: "completedProjects",
            children: (
              <Table
                rowKey={(r) => r.id}
                loading={loading}
                title={() =>
                  TableTitle({
                    search,
                    setfilterTableNull,
                    refreshTable,
                    exportRecords,
                    openAddModal,
                  })
                }
                bordered={true}
                dataSource={filterTable === null ? data.completedBudgets : filterTable}
                columns={columns}
              />
            ),
          }
        ]}
      />

    </div>
  );
};

export default BudgetsTable;
